import { get, isFunction } from 'lodash';

export const fileDownload = (data, filename, type) => {
    const file = new Blob([data], { type });
    const msSaveOrOpenBlob = get(window.navigator, 'msSaveOrOpenBlob');

    if (isFunction(msSaveOrOpenBlob)) {
      msSaveOrOpenBlob(file, filename);

      return;
    }

    const link = document.createElement('a');
    const url = URL.createObjectURL(file);

    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  };